import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switchLocale(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    const currentUrl = new URL(window.location.href)
    
    // Update the locale parameter
    currentUrl.searchParams.set('locale', locale)
    
    // Navigate to the new URL
    window.location.href = currentUrl.toString()
  }
}
